import { useStore } from '@nanostores/react';
import { useEffect, useState } from 'react';
import { Button } from '~/components/ui/Button';
import { redirectToPersonalBillingPage } from '~/lib/stores/pricing/helpers';
import { proPricingPlansStore } from '~/lib/stores/pricing/proPlans';
import { teamPricingPlansStore } from '~/lib/stores/pricing/teamPlans';
import { userStore } from '~/lib/stores/user';
import { redirectToOrgBillingPage } from '~/utils/subscription';

import { withSpinner } from '~/utils/withSpinner';

export const PendingUpdateBanner = () => {
  const user = useStore(userStore.user);
  const activeOrganization = useStore(userStore.getActiveOrganization());

  const [isPendingUpdate, setIsPendingUpdate] = useState(false);
  const [showControlButtons, setShowControlButtons] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const subscription = activeOrganization ? activeOrganization.billing?.subscription : user?.membership?.subscription;

  useEffect(() => {
    const isExpiredUpdate = subscription?.pendingUpdate
      ? subscription.pendingUpdate.expiresAt * 1000 <= Date.now()
      : false;

    if (isExpiredUpdate) {
      return;
    }

    if (activeOrganization) {
      if (!!subscription?.pendingUpdate) {
        setIsPendingUpdate(true);

        if (activeOrganization.role === 'admin') {
          setShowControlButtons(true);
        }
      }
    } else if (!!subscription?.pendingUpdate) {
      setIsPendingUpdate(true);
      setShowControlButtons(true);
    }
  }, [user, activeOrganization]);

  if (!isPendingUpdate || !subscription?.pendingUpdate) {
    return null;
  }

  function cancelSubscription() {
    withSpinner({
      action: async () => {
        if (activeOrganization) {
          await teamPricingPlansStore.cancelSubscriptionUpdate(activeOrganization);
        } else {
          await proPricingPlansStore.cancelSubscriptionUpdate();
        }
      },
      onStateUpdate: setIsLoading,
    });
  }

  function redirectToBillingPage() {
    if (activeOrganization) {
      redirectToOrgBillingPage(activeOrganization);
    } else {
      redirectToPersonalBillingPage();
    }
  }

  return (
    <div className="flex items-start gap-3 p-4 bg-bolt-ds-warningContainer border border-bolt-ds-warningOutline rounded-lg">
      <div className="i-ph:warning text-bolt-ds-warning text-lg shrink-0 mt-0.5" />
      <div className="flex-1">
        <h3 className="text-bolt-elements-textWarning font-semibold text-sm mb-1 mt-0.5">
          We couldn't upgrade your subscription
        </h3>
        <p className="text-bolt-elements-textSecondary text-sm mb-2">
          We weren’t able to process the payment for your upgrade. Don't worry — you’ll stay on your current paid plan
          while we automatically retry the payment over the next few days. If you’d prefer to use a different card or
          cancel the upgrade, you can do that below.
        </p>
        <div className="flex gap-3">
          {showControlButtons && (
            <div className="flex gap-3">
              <Button variant="secondary" size="sm" onClick={redirectToBillingPage}>
                Update payment method
              </Button>
              <Button variant="ghost" size="sm" onClick={cancelSubscription} disabled={isLoading} loading={isLoading}>
                Cancel upgrade
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
